<template>
  <div class="page">
    <div class="page-header">
      <Content>
        <h1>Redirecting you to your deal...</h1>
      </Content>
    </div>
    <Content>
      <FlexContainer>
        <FlexItem padding="normal" :grow="true">
          <p>
            If you are not redirected
            <a :href="deal.url">click here</a>.
          </p>
        </FlexItem>
      </FlexContainer>
    </Content>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  metaInfo() {
    return {
      // title: this.category.name,
    };
  },
  data: function() {
    return {
      deal: {}
    };
  },
  computed: {
    ...mapGetters({
      getDeal: "deal/getDeal",
      getPublisher: "publisher/getPublisher"
    })
  },
  watch: {
    $route: {
      immediate: true,
      async handler(to) {
        let link1 = `https://www.awin1.com/cread.php?awinmid=3&awinaffid=695889&clickref=link_id&ued=https%3A%2F%2Fwww.johnlewis.com%2Fsilver-cross-pacific-pushchair-bronze%2Fp4903202`;
        let link2 = `https://www.awin1.com/cread.php?awinmid=20042&awinaffid=695889&clickref=link_id&ued=https%3A%2F%2Fwww.johnlewis.com%2Fsilver-cross-pacific-pushchair-bronze%2Fp4903202`;
        let vgLink = `https://redirect.viglink.com?key=a535ac1775661b0ccbc2e1c98e06b549&u=https%3A%2F%2Fwww.argos.co.uk%2Fproduct%2F4038896&cuid=5w6zFOfEC9u30l7bPuFf`;

        const affiliateId = "695889";
        this.deal = await this.getDeal(to.params.id);
        this.publisher = await this.getPublisher(this.deal.publisherId);
        const link = `https://www.awin1.com/cread.php?awinmid=${this.publisher.awinId}&awinaffid=${affiliateId}&clickref=${this.deal.id}&p=${this.deal.url}`;

        if (this.publisher.awinId) {
          window.location = link;
        } else {
          window.location = this.deal.url;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page {
  flex: 1;
}
.page-header {
  background: $primary;
  padding: $padding-large 0;

  h1 {
    font-size: 3rem;
    font-weight: 400;
    color: $white;
  }

  p {
    color: $white;
  }

  @media (max-width: $width-sm) {
    padding: $padding 0;
  }
}
</style>
